import React, { useEffect, useRef, useState } from "react";
import Sortable from "sortablejs";
import "../../style/customizedash.css";
import useCustomizeDash from "../../hooks/useCustomizeDash";

const dummySideComponents = [
  { key: "target_roles", label: "Target Roles" },
  { key: "target_industries", label: "Target Industries" },
  { key: "timeline", label: "My Career Roadmap" },
  { key: "short_term_goals", label: "Short Term Goals" },
  { key: "professional_summary", label: "Professional Summary" },
  { key: "upcoming_meetings", label: "Upcoming Meetings" },
  { key: "target_work_environment", label: "Target Work Environment" },
  { key: "my_tasks", label: "My Tasks" },
  { key: "calendar", label: "Calendar" },
];

const CustomizeDash = () => {
  
  const { isDropdownOpen, handleToggleDropdown } = useCustomizeDash();
  const sidePanelRef = useRef(null);

  const handleClickOutside = (event) => {
    const sectionRight = document.querySelector(".main-right-container");
    const sectionLeft = document.querySelector(".main-left-container");
    const customizeDashClass = document.querySelector(".customize-dashboard-btn");
    // console.log('sss event', event.target, event.target.classList.contains('delete-icon'))
    if (
      (isDropdownOpen) &&
      (sectionRight && sectionRight.contains(event.target) || sectionLeft && sectionLeft.contains(event.target) ) &&
      (sidePanelRef.current && !sidePanelRef.current.contains(event.target)) &&
      (!event.target.classList.contains('delete-icon'))
    ) {
      handleToggleDropdown(false)
    }
    
    if(
      (isDropdownOpen) &&
      (customizeDashClass && customizeDashClass.contains(event.target)) &&
      (sidePanelRef.current && !sidePanelRef.current.contains(event.target)) &&
      (!event.target.classList.contains('delete-icon'))
    ){
      handleToggleDropdown(true)
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    new Sortable(sidePanelRef.current, {
      group: { name: "shared_dash", pull: "clone", put: false }, // ✅ Clone only, do NOT move items
      animation: 150,
      sort: false,
      onStart: (evt) => {
        evt.item.classList.add("dragging");
      },
      onEnd: (evt) => {
        evt.item.classList.remove("dragging");
      },
      onClone: (evt) => {
        evt.clone.setAttribute("data-source", "customizeDash"); // ✅ Ensure cloned item has correct attribute
      },
    });
  }, []);

  const customizeDasButton = () => {
    handleToggleDropdown(false)
  }
  
  return (
    <div className="customize-dashboard-wrapper">
      <button className="customize-dashboard-btn" onClick={customizeDasButton}>
        Customize Dashboard
      </button>
      <div className="customize-dashboard-dropdown" style={{ display: isDropdownOpen ? "block" : "none" }}>
        <div className="customize-dashboard-list" ref={sidePanelRef}>
          {dummySideComponents.map((item) => (
            <div 
              key={item.key} 
              className="customize-dashboard-item" 
              data-id={item.key}
              data-key={item.key}
              data-label={item.label}
              data-source="customizeDash"
            >
              <span style={{ cursor: "pointer" }}>
                <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg" />
              </span>
              <span style={{ cursor: "pointer" }}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomizeDash;
